import ManageAccessBulkAction from './ManageAccessBulkAction';
export default ManageAccessBulkAction;